import { Field, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import DeleteIcon from "../../../assets/icons/delete-icon";
import "../../forms/form.css";
import SearchAddFeild from "../../forms/search-add-field";
import errorToast from "../../helper-components/error-toast";
import useBarcodeScanner from "../../helper-components/helper-function";
import { invoiceScannedItemAction } from "../../../redux/actions/invoices-action";
import SelectField from "../../forms/select-field";
import { stockTransferBatchAction } from "../../../redux/actions/inventory-action";
import { defaultBinLocationAction } from "../../../redux/actions/general-action";
import {
  purchaseProductDetailsAction,
  purchaseProductListAction,
} from "../../../redux/actions/purchase-action";
import AddButton from "../../buttons/button";
import { convertBatchesToUom } from "../../../utils/stock-transfer-calculations";

const StocktransferItemSec = ({
  initialData,
  disabled = false,
  searchRef,
  addBatchFn = () => { },
  heading = [],
}) => {
  const inputRefs = useRef(null);
  const { values, setFieldValue } = useFormikContext();

  // Block adding items until both source (from) and destination (to)
  // warehouses are selected.
  const isWarehouseSelected =
    values?.from_warehouse_id?.length > 0 &&
    values?.to_warehouse_id?.length > 0;

  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  // const heading = [
  //   { label: "S No.", value: "sl_no" },
  //   { label: "Product Name", value: "item_name" },
  //   { label: "Item Code", value: "item_code" },
  //   { label: "UOM", value: "item_uom" },
  //   { label: "Qty", value: "item_quantity" },
  //   {
  //     label: "Batches",
  //     value: "item_batches",
  //     enabled: true,
  //     alignment: "center",
  //     childrenHeading: [
  //       {
  //         label: "Batch",
  //         value: "item_batch_number",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Final PR",
  //         value: "item_batch_purchase_rate",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "MRP",
  //         value: "item_batch_unit_price",
  //         enabled: true,
  //         minWidth: 10,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Quantity",
  //         value: "item_batch_quantity",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Free Quantity",
  //         value: "item_batch_free_quantity",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Expiry",
  //         value: "item_exp_date",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //     ],
  //   },

  //   { label: "Current Avail", value: "current_availability" },
  //   { label: "Clear All", value: "clear_all" },
  // ];
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const options =
        data?.data === null
          ? []
          : data.data
            .map((item) => ({
              value: item.item_id,
              label: item[field],
            }))
            .filter(
              (option) =>
                !values?.data?.some((item) => item?.item_id === option.value)
            );
      setLocalData(data.data);
      callback(options);
    };
    const onError = (data) => { };
    if (inputValue?.length > 0) {
      dispatch(
        // productListAction(
        purchaseProductListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const removeRow = (rowIndex) => {
    const updatedData = [...values.data];
    updatedData.splice(rowIndex, 1);
    setFieldValue("data", updatedData);
  };

  const handleQuantityChange = async (event, rowIndex) => {
    const updatedData = values.data.map((row, index) =>
      index === rowIndex
        ? { ...row, quantity: parseFloat(event.target.value) }
        : row
    );
    setFieldValue("data", updatedData);
  };

  const hasDuplicateItemId = (itemId, currentIndex) => {
    const itemIdsExceptCurrent = values.data
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.item_id);

    return itemIdsExceptCurrent.includes(itemId);
  };

  // Default dropping bin — where scanned batches land for Stock IN / In Store
  // Transfer, same default as the batches panel
  const [defaultDroppingBin, setDefaultDroppingBin] = useState(null);
  useEffect(() => {
    dispatch(
      defaultBinLocationAction(
        { field: "default_dropping_bin" },
        (data) => setDefaultDroppingBin(data?.data ?? null),
        () => { }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ignore scans while the previous one is still being added, otherwise a
  // quick rescan works off stale table data.
  const isScanningRef = useRef(false);

  // Scanning an item that is already on the table: true adds 1 to its qty,
  // false rejects the scan with an "already added in row N" toast
  const [addQtyOnRescan, setAddQtyOnRescan] = useState(false);

  // The scanner types the barcode into whichever item search has focus. The
  // search keeps its own input text, so remount the empty row's search fields
  // after each scan to clear it, then put the cursor back in the search.
  const [scanResetKey, setScanResetKey] = useState(0);
  useEffect(() => {
    if (scanResetKey > 0) searchRef?.current?.focus?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanResetKey]);

  const dispatchAsync = (action, payload) =>
    new Promise((resolve) => {
      dispatch(action(payload, resolve, () => resolve(null)));
    });

  const isStockIn = values?.stock_management_action === "stock_in";
  const isInStoreTransfer =
    values?.stock_management_action === "in_store_transfer";
  const isTransferRequest =
    values?.stock_management_action === "stock_transfer_request";

  const getRowBaseQty = (row) => parseFloat(row?.base_quantity) || 1;

  // Bin the scanned stock is going to (Stock OUT has no destination bin)
  const getScanToBin = () => {
    if (isInStoreTransfer && values?.expiry_to_bin_id) {
      return {
        to_bin_id: values.expiry_to_bin_id,
        to_bin_location: values?.expiry_to_bin_location ?? "",
      };
    }
    if (isStockIn || isInStoreTransfer) {
      return {
        to_bin_id: defaultDroppingBin?.bin_no_id ?? "",
        to_bin_location: defaultDroppingBin?.bin_location_no ?? "",
      };
    }
    return { to_bin_id: "", to_bin_location: "" };
  };

  const withBatchTotals = (row, item_batches) => ({
    ...row,
    item_batches,
    quantity: item_batches.reduce(
      (sum, batch) => sum + (parseFloat(batch?.item_batch_quantity) || 0),
      0
    ),
  });

  // Same row the item search builds, from a scanned item
  const buildScannedRow = async (foundItem) => {
    const baseRow = {
      sl_no: 1,
      item_name: foundItem?.item_name,
      item_code: foundItem?.item_code,
      item_uom: foundItem?.item_pur_purchasing_uom_name ?? "",
      quantity: 0,
      item_batches: [],
      current_avail: {
        item_uom_source: "",
        item_uom_destination: "",
      },
      total_sellable_quantity: 0,
      base_total_sellable_quantity: 0,
      item_id: foundItem?.item_id,
      uom_dropdown: [],
      item_uom_id:
        foundItem?.item_pur_purchasing_uom_name_id ??
        foundItem?.item_uom_id ??
        "",
      base_quantity: 0,
      uom_group_id: foundItem?.item_uom_id || foundItem?.item_uom || "",
    };
    const detailData = await dispatchAsync(purchaseProductDetailsAction, {
      item_id: baseRow.item_id,
      item_uom: baseRow.uom_group_id,
    });
    if (!detailData) return null;
    return buildDetailedRow(detailData, baseRow);
  };

  // Scanned barcode with a batch: each scan adds 1 (in the row's UOM) of
  // exactly that batch. The batch can sit in several bins — the unit goes onto
  // the batch line of a bin that still has room for it, otherwise onto a new
  // line for the next bin with stock.
  const addScannedBatch = async (row, batchNumber, rowNo) => {
    const baseQty = getRowBaseQty(row);
    const batches = [...(row?.item_batches ?? [])];
    const toBin = getScanToBin();

    const batchListData = await dispatchAsync(
      stockTransferBatchAction,
      row?.item_id
    );
    const batchList = (batchListData?.data ?? []).filter(
      (bch) => bch?.item_batch_number === batchNumber
    );

    if (isStockIn) {
      // Stock IN brings new stock in — reuse the batch's rates if we know it
      const existingIndex = batches.findIndex(
        (bch) => bch?.item_batch_number === batchNumber
      );
      if (existingIndex >= 0) {
        batches[existingIndex] = {
          ...batches[existingIndex],
          item_batch_quantity:
            (parseFloat(batches[existingIndex]?.item_batch_quantity) || 0) + 1,
        };
        return withBatchTotals(row, batches);
      }
      const known = batchList[0];
      if (!known) {
        errorToast(
          `Batch ${batchNumber} not found. Please add its details manually.`
        );
        return null;
      }
      batches.push({
        item_id: row?.item_id,
        item_batch_number: batchNumber,
        item_batch_quantity: 1,
        item_batch_free_quantity: 0,
        item_batch_purchase_rate: known?.item_batch_purchase_rate ?? 0,
        item_batch_unit_price: known?.item_batch_unit_price ?? 0,
        item_batch_discount_percentage: 0,
        item_batch_discount_amount: 0,
        item_exp_date: known?.item_exp_date
          ? moment(known.item_exp_date).format("YYYY-MM-DD")
          : "",
        from_bin_id: "",
        from_bin_location: "",
        created_date: "",
        remainingQty: 0,
        ...toBin,
      });
      return withBatchTotals(row, batches);
    }

    // Stock OUT / In Store Transfer pick from stock that exists. In Store
    // Transfer can't move a batch into the bin it already sits in.
    const bins = batchList
      .filter((bch) => (parseFloat(bch?.item_quantity) || 0) > 0)
      .filter((bch) => !(isInStoreTransfer && bch?.to_bin_id === toBin.to_bin_id))
      .sort(
        (a, b) =>
          (parseFloat(b?.item_quantity) || 0) -
          (parseFloat(a?.item_quantity) || 0)
      );
    if (bins.length === 0) {
      errorToast(`Batch ${batchNumber} qty is 0`);
      return null;
    }

    for (const bin of bins) {
      const lineIndex = batches.findIndex(
        (bch) =>
          bch?.item_batch_number === batchNumber &&
          bch?.from_bin_id === bin?.to_bin_id
      );
      const heldUnits =
        lineIndex >= 0
          ? (parseFloat(batches[lineIndex]?.item_batch_quantity) || 0) * baseQty
          : 0;
      const binUnits = parseFloat(bin?.item_quantity) || 0;
      if (binUnits - heldUnits < baseQty) continue;

      if (lineIndex >= 0) {
        batches[lineIndex] = {
          ...batches[lineIndex],
          item_batch_quantity:
            (parseFloat(batches[lineIndex]?.item_batch_quantity) || 0) + 1,
          remainingQty: binUnits,
        };
      } else {
        batches.push({
          item_id: row?.item_id,
          item_batch_number: batchNumber,
          item_batch_quantity: 1,
          item_batch_free_quantity: bin?.item_batch_free_quantity ?? 0,
          item_batch_purchase_rate: bin?.item_batch_purchase_rate ?? 0,
          item_batch_unit_price: bin?.item_batch_unit_price ?? 0,
          item_batch_discount_amount: bin?.item_batch_discount_amount ?? 0,
          item_batch_discount_percentage:
            bin?.item_batch_discount_percentage ?? 0,
          item_exp_date: bin?.item_exp_date
            ? moment(bin.item_exp_date).format("YYYY-MM-DD")
            : "",
          from_bin_id: bin?.to_bin_id ?? "",
          from_bin_location: bin?.item_rack_location ?? "",
          created_date: bin?.created_date ?? "",
          remainingQty: binUnits,
          ...toBin,
        });
      }
      return withBatchTotals(row, batches);
    }

    const availableQty = bins.reduce(
      (sum, bin) => sum + (parseFloat(bin?.item_quantity) || 0),
      0
    );
    errorToast(
      `${row?.item_name ?? "Item"}${rowNo ? ` (row ${rowNo})` : ""
      }: cannot exceed available qty ${Math.floor(availableQty / baseQty)} ${row?.item_uom ?? ""
        }`.trim()
    );
    return null;
  };

  const onScanned = async (foundItem) => {
    const scannedBatchNumber =
      foundItem?.batch_number_exists && foundItem?.batch_number
        ? foundItem.batch_number
        : "";
    const rows = values?.data ?? [];
    const filledRows = rows.slice(0, -1);
    const existingIndex = filledRows.findIndex(
      (row) => row?.item_id === foundItem?.item_id
    );

    // Item scanned again: add qty to its row, or reject the scan
    if (existingIndex >= 0 && !addQtyOnRescan) {
      errorToast(
        `${filledRows[existingIndex]?.item_name ?? "Item"
        } is already added in row ${existingIndex + 1}`
      );
      return;
    }

    // Barcode without a batch on an item already on the table: +1 on its last
    // batch (stock checked), or on the row qty when it has no batches yet
    if (!scannedBatchNumber && existingIndex >= 0) {
      const existingRow = filledRows[existingIndex];
      const lastBatchNumber =
        existingRow?.item_batches?.[existingRow.item_batches.length - 1]
          ?.item_batch_number;
      const updatedRow =
        !isTransferRequest && lastBatchNumber
          ? await addScannedBatch(
            existingRow,
            lastBatchNumber,
            existingIndex + 1
          )
          : {
            ...existingRow,
            quantity: (parseFloat(existingRow?.quantity) || 0) + 1,
          };
      if (!updatedRow) return;
      const updated = [...rows];
      updated[existingIndex] = updatedRow;
      setFieldValue("data", updated);
      return;
    }

    let row = existingIndex >= 0 ? filledRows[existingIndex] : null;
    if (!row) {
      row = await buildScannedRow(foundItem);
      if (!row) {
        errorToast("Failed to fetch item details");
        return;
      }
    }

    // A transfer request carries no batches — the batch on the barcode only
    // identifies the item
    if (isTransferRequest) {
      row = { ...row, quantity: (parseFloat(row?.quantity) || 0) + 1 };
    } else if (scannedBatchNumber) {
      const updatedRow = await addScannedBatch(
        row,
        scannedBatchNumber,
        existingIndex >= 0 ? existingIndex + 1 : null
      );
      if (!updatedRow) {
        // Still put a new item on the table so its batch can be added by hand
        if (existingIndex < 0 && isStockIn) {
          setFieldValue("data", [...filledRows, row, initialData]);
          addBatchFn(row?.item_id);
        }
        return;
      }
      row = updatedRow;
    }

    if (existingIndex >= 0) {
      const updated = [...rows];
      updated[existingIndex] = row;
      setFieldValue("data", updated);
    } else {
      setFieldValue("data", [...filledRows, row, initialData]);
    }
  };

  useBarcodeScanner((barcode) => {
    // The scanner types into the focused item search — close the menu it opened
    searchRef?.current?.onMenuClose?.();
    setScanResetKey((key) => key + 1);
    if (!barcode || disabled || isScanningRef.current) return;
    if (!isWarehouseSelected) {
      errorToast("Please select source and destination warehouses first");
      return;
    }
    isScanningRef.current = true;
    dispatch(
      invoiceScannedItemAction(
        barcode,
        async (data) => {
          try {
            // /product/barcode/get returns { item_information, ... }; billing's
            // variant returns a list of items
            const foundItem = Array.isArray(data?.data)
              ? data.data[0]
              : data?.data?.item_information;
            if (!foundItem) {
              errorToast("No product found for scanned barcode");
              return;
            }
            await onScanned(foundItem);
          } finally {
            isScanningRef.current = false;
          }
        },
        (data) => {
          isScanningRef.current = false;
          errorToast(data?.data?.message ?? "Failed to add scanned item");
        }
      )
    );
  });

  function fetchBatchfn(id, index) {
    dispatch(
      stockTransferBatchAction(
        id,
        (data) => {
          if (index) {
            setFieldValue(`data[${index}].itemBatchList`, data?.data);
          }
        },
        (data) => { }
      )
    );
  }

  const onSuccessDetails = (data, rowIndex, filteredData) => {
    const oldData = [...values?.data];
    oldData.pop();
    setFieldValue("data", [
      ...oldData,
      buildDetailedRow(data, filteredData),
      initialData,
    ]);
    inputRefs.current?.focus();
  };

  const buildDetailedRow = (data, filteredData) => {
    const rawUomList = data?.data?.uom_dropdown ?? [];
    // Find the default UOM: try ID match → name match → first entry as last resort
    const matchedUom =
      rawUomList.find((uom) => uom?.item_id === filteredData?.item_uom_id) ??
      rawUomList.find((uom) => uom?.alt_uom === filteredData?.item_uom) ??
      rawUomList[0];
    const resolvedBaseQty = parseFloat(matchedUom?.base_quantity) || 1;
    const rawSellableQuantity =
      parseFloat(data?.data?.total_sellable_quantity) || 0;
    return {
      ...filteredData,
      item_uom: filteredData?.item_uom || matchedUom?.alt_uom || "",
      base_quantity: resolvedBaseQty,
      item_uom_id: matchedUom?.item_id ?? filteredData?.item_uom_id,
      base_total_sellable_quantity: rawSellableQuantity,
      total_sellable_quantity: rawSellableQuantity / resolvedBaseQty,
      uom_dropdown: rawUomList.map((uom) => ({
        item_uom_id: uom?.item_id,
        label: uom?.alt_uom,
        value: uom?.alt_uom,
        base_quantity: uom?.base_quantity,
      })),
    };
  };

  const onErrorDetails = (data) => { };

  return (
    <>
      <div
        style={{
          maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
          height: "auto", // Let it grow naturally to fit its content
        }}
        className={`border border-[var(--create-table-main-border)] border-1 border-radius px-3 pb-3`}
      >
        <div
          style={{
            maxHeight: `100%`,
            minHeight: `5rem`,
          }}
          className={`tab-container border-radius mt-[1rem]`}
        >
          <table className="w-full border-collapse mt-0">
            <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
              <tr className="relative h-[50px]">
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => (
                    <th
                      style={{ minWidth: `${heading?.minWidth}px` }}
                      key={index}
                      className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                    >
                      {heading?.value === "clear_all" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                            width: "100%", // Ensure the div takes full width of the th
                          }}
                        >
                          {!disabled && (
                            <AddButton
                              type="button"
                              onclkFn={() => {
                                setFieldValue("data", [initialData]);
                              }}
                              prefixIcon={false}
                              text={"Clear All"}
                              className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                            />
                          )}
                        </div>
                      ) : heading?.childrenHeading?.length > 0 ? (
                        <div className="flex gap-3">
                          {heading?.childrenHeading?.map(
                            (childHeading, childIndex) => (
                              <div
                                style={{
                                  minWidth: `100px`,
                                  width: `${heading?.minWidth}px`,
                                  textAlign: childHeading?.alignment, // Keep textAlign for normal text cells
                                }}
                                className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                              text-[length:var(--create-table-batch-con-fs)] 
                              font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                              >
                                {childHeading?.label}
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 w-full"
                          style={{
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                          }}
                        >
                          {heading?.label}
                        </div>
                      )}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="h-full">
              {values?.data?.map((rowData, rowIndex) => (
                <tr
                  className={` bg-[var(--create-table-row-bg)] h-[50px] `}
                  key={rowIndex}
                >
                  {heading
                    ?.filter((heading) => heading?.enabled !== false)
                    ?.map((heading, index) => {
                      return (
                        <td
                          style={{
                            minWidth: `${heading?.minWidth}px`,
                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                          }}
                          key={index}
                          className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                        >
                          {heading.value === "item_name" ||
                            heading.value === "item_code" ||
                            heading.value === "item_generic_name" ? (
                            <div
                              title={rowData[heading.value]}
                              key={
                                rowIndex === values?.data?.length - 1
                                  ? `scan-${scanResetKey}`
                                  : "row"
                              }
                            >
                              <SearchAddFeild
                                menuWidth="35rem"
                                searchRef={
                                  heading.value === "item_name" ? searchRef : {}
                                }
                                isDisabled={
                                  values?.data?.length - 1 !== rowIndex ||
                                    disabled ||
                                    !isWarehouseSelected
                                    ? true
                                    : false
                                }
                                errorClass="hidden"
                                isRequired={false}
                                value={{
                                  label: rowData[heading.value],
                                  value: "",
                                }}
                                name={`data[${rowIndex}].${heading.value}`}
                                field={heading.value}
                                isLabelReq={false}
                                defaultSelectClass=""
                                placeholder=""
                                fetchData={fetchData}
                                onChange={async (selectedOption) => {
                                  const filteredData = localData
                                    ?.filter(
                                      (item) =>
                                        item?.item_id === selectedOption?.value
                                    )
                                    .map((item) => ({
                                      sl_no: 1,
                                      item_name: item.item_name,
                                      item_code: item.item_code,
                                      item_uom:
                                        item.item_pur_purchasing_uom_name ===
                                          null
                                          ? ""
                                          : item.item_pur_purchasing_uom_name,
                                      quantity: 0,
                                      item_batches: [],
                                      current_avail: {
                                        item_uom_source: "",
                                        item_uom_destination: "",
                                      },
                                      total_sellable_quantity: 0,
                                      base_total_sellable_quantity: 0,
                                      item_id: item?.item_id,
                                      uom_dropdown: [],
                                      // uom_dropdown: item?.uom_dropdown
                                      //   ? item?.uom_dropdown.map((uom) => ({
                                      //       item_uom_id: uom?.item_id,
                                      //       label: uom?.alt_uom,
                                      //       value: uom?.alt_uom,
                                      //       base_quantity: uom?.base_quantity,
                                      //     }))
                                      //   : [],
                                      item_uom_id:
                                        item?.item_pur_purchasing_uom_name_id ??
                                        "",
                                      base_quantity: 0,
                                      // base_quantity: item?.uom_dropdown
                                      //   ? parseInt(
                                      //       item?.uom_dropdown.find(
                                      //         (uom) =>
                                      //           uom?.item_id ===
                                      //           item?.item_pur_purchasing_uom_name_id
                                      //       )?.base_quantity ?? 0
                                      //     ) || 0
                                      //   : 0,
                                      uom_group_id: item?.item_uom || "",
                                    }));
                                  dispatch(
                                    purchaseProductDetailsAction(
                                      {
                                        item_id: filteredData?.[0]?.item_id,
                                        item_uom:
                                          filteredData?.[0]?.uom_group_id,
                                      },
                                      (data) => {
                                        onSuccessDetails(
                                          data,
                                          rowIndex,
                                          ...filteredData
                                        );
                                      },
                                      onErrorDetails
                                    )
                                  );
                                }}
                              />
                            </div>
                          ) : heading.value === "item_quantity" ? (
                            <div className="flex w-full">
                              <Field name={`data[${rowIndex}].quantity`}>
                                {({ field }) => (
                                  <input
                                    min={0}
                                    ref={inputRefs}
                                    {...field}
                                    type="number"
                                    step="1"
                                    placeholder=""
                                    // disabled={!values.data[rowIndex]?.item_uom}
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled
                                    }
                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "-" ||
                                        event.key === "e" ||
                                        event.key === "."
                                      ) {
                                        event.preventDefault();
                                      }
                                      if (
                                        event.key === "Tab" ||
                                        event.key === "Enter"
                                      ) {
                                        handleQuantityChange(event, rowIndex);
                                        setFieldValue(
                                          `data[${rowIndex}].quantity`,
                                          event.target.value
                                        );
                                        // if (searchRef && searchRef.current) {
                                        //   setTimeout(() => {
                                        //     searchRef.current.focus();
                                        //   }, 0);
                                        // }
                                      }
                                    }}
                                    onFocus={(e) => e.target.select()}
                                    className="focus-within:ring-2 min-w-[3rem] max-w-[5rem]  px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading.value === "item_uom" ? (
                            <SelectField
                              defaultInputClass="min-h-[42px] rounded-[8px]  text-[var(--create-table-row-fg-color)] text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] input-field-no-spin-buttons placeholder:text-[var(--create-table-row-placeholder-color)] placeholder:text-[length:var(--create-table-batch-con-fs)] placeholder:font-[var(--create-table-row-font-weight)]  "
                              borderclass=""
                              defaultSelectClass="border-0"
                              inputBorder=""
                              general_color={false}
                              handleSelected={(sel) => {
                                const newBaseQty =
                                  parseFloat(sel?.base_quantity) || 1;
                                const rawSellableQuantity =
                                  parseFloat(
                                    rowData?.base_total_sellable_quantity
                                  ) || 0;
                                setFieldValue(
                                  `data[${rowIndex}].item_uom_id`,
                                  sel?.item_uom_id
                                );
                                setFieldValue(
                                  `data[${rowIndex}].base_quantity`,
                                  newBaseQty
                                );
                                setFieldValue(
                                  `data[${rowIndex}].total_sellable_quantity`,
                                  rawSellableQuantity / newBaseQty
                                );
                                // Batches loaded from expiry items carry
                                // per-unit stock and rates, so re-price them
                                // in the newly picked UOM.
                                if (
                                  rowData?.item_batches?.some(
                                    (batch) =>
                                      batch?.unit_batch_quantity !== undefined
                                  )
                                ) {
                                  const convertedBatches = convertBatchesToUom(
                                    rowData.item_batches,
                                    newBaseQty
                                  );
                                  setFieldValue(
                                    `data[${rowIndex}].item_batches`,
                                    convertedBatches
                                  );
                                  setFieldValue(
                                    `data[${rowIndex}].quantity`,
                                    convertedBatches.reduce(
                                      (sum, batch) =>
                                        sum +
                                        (parseFloat(
                                          batch.item_batch_quantity
                                        ) || 0),
                                      0
                                    )
                                  );
                                }
                              }}
                              value_color="var(--secondary)"
                              selectClass="w-full"
                              defaultValue={
                                values.data[rowIndex]?.item_uom
                                  ? {
                                    label:
                                      values.data[rowIndex]?.item_uom ?? "",
                                  }
                                  : null
                              }
                              isDisabled={disabled}
                              errMsgContainerClass="hidden"
                              id={`data[${rowIndex}].item_uom`}
                              isContainer={false}
                              options={values.data[rowIndex]?.uom_dropdown}
                              name={`data[${rowIndex}].item_uom`}
                              placeholder={"Select UOM"}
                              style={customStyles}
                            />
                          ) : heading.value === "item_batches" ? (
                            <div className="py-1">
                              {rowIndex < values?.data?.length - 1 &&
                                values?.stock_management_action !==
                                "stock_transfer_request" &&
                                values.data[rowIndex]?.quantity > 0 &&
                                rowData.item_batches?.length === 0 && (
                                  <button
                                    onClick={() => {
                                      addBatchFn(rowData?.item_id);
                                    }}
                                    type="button"
                                    className="text-[var(--create-table-row-placeholder-color)]   w-full"
                                  >
                                    {disabled
                                      ? "View batch details"
                                      : "Click to" +
                                        rowData.item_batches?.length >
                                        0
                                        ? "Update"
                                        : "Add"}
                                  </button>
                                )}

                              {Array.isArray(rowData.item_batches) &&
                                rowData.item_batches.map((batch, index) => (
                                  <div
                                    onClick={() => addBatchFn(rowData?.item_id)}
                                    className="flex items-center gap-3 mt-[0.5rem]"
                                  >
                                    {heading?.childrenHeading
                                      ?.filter(
                                        (heading) => heading?.enabled !== false
                                      )
                                      ?.map((heading, index) => (
                                        <div
                                          style={{
                                            minWidth: `100px`,
                                            width: `${heading?.minWidth}px`,
                                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                          }}
                                          className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                                      text-[length:var(--create-table-batch-con-fs)] 
                                      font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                                        >
                                          {batch[heading?.value] ?? "-"}
                                        </div>
                                      ))}
                                  </div>
                                ))}
                            </div>
                          ) : heading.value === "clear_all" ? (
                            <button
                              type="button"
                              disabled={
                                disabled || rowIndex >= values?.data?.length - 1
                              }
                              onClick={() => {
                                removeRow(rowIndex, "");
                              }}
                              style={{
                                display: "flex",
                                justifyContent:
                                  heading?.alignment === "right"
                                    ? "flex-end"
                                    : heading?.alignment === "center"
                                      ? "center"
                                      : "flex-start",
                                width: "100%", // Take full width of the td
                              }}
                            >
                              {/* the last row is the empty one new items are added from */}
                              {!disabled &&
                                rowIndex < values?.data?.length - 1 && (
                                  <DeleteIcon className="cursor-pointer text-red-500" />
                                )}
                            </button>
                          ) : heading.value === "sl_no" ? (
                            rowIndex + 1
                          ) : (
                            rowData[heading.value] ?? "--"
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default StocktransferItemSec;

const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    fontFamily: "Inter,sans-serif ",
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
    borderRadius: "10px",
    width: "100%",
    backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    height: "100%",
  }),
  option: (provided, state) => {
    const defaultBackgroundColor = "white"; // Default background color
    const focusedBackgroundColor = "#0000002E"; // Background color when focused
    const selectedBackgroundColor = "#e5ecffb2"; // Background color when selected

    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      // backgroundColor: state?.isSelected ? "red" : "red",
      backgroundColor: state.isSelected
        ? selectedBackgroundColor // Use selected background color
        : state.isFocused
          ? focusedBackgroundColor // Use focused background color
          : defaultBackgroundColor, // Use default background color

      fontSize: "14px",
      zIndex: "999",
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused
          ? focusedBackgroundColor
          : focusedBackgroundColor, // Keeps hover state consistent
      },
    };
  },
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--placeholder-color)",
      fontFamily: "Inter,sans-serif",
      // fontSize: "14px",
      fontWeight: "400",
      opacity: "1",
      // position: "absolute",
      // top: "30%",
      whiteSpace: "nowrap",
    };
  },
  multiValue: (base) => ({
    ...base,
    fontFamily: "Inter,sans-serif ",
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    ...(state.selectProps.menuIsOpen
      ? {
        transform: "rotate(180deg)",
      }
      : {}),
  }),
};
